/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigurationResponse } from '../../models/configuration-response';
import { CreateConfigurationRequest } from '../../models/create-configuration-request';

export interface CreateOptsConfigurations$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: CreateConfigurationRequest
}

export function createOptsConfigurations(http: HttpClient, rootUrl: string, params: CreateOptsConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, createOptsConfigurations.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigurationResponse>;
    })
  );
}

createOptsConfigurations.PATH = '/stores/{storeId}/preptimes';
